<template>
	<div>
    <router-link :to="{ name: 'line', params: { lin: '1-AGUA' }}">
      <div class="categories_menu">
        <div class="products_title">
          <h2>{{ $t('Productos') }}</h2>
        </div>
      </div>
    </router-link>
	</div>
</template>

<i18n>
  {
		"es": {
      "Productos": "Productos"
    },
    "en":{
      "Productos": "Products"
    }
  }
</i18n>

<script>
	import { mapGetters } from 'vuex'

	export default {
	  data () {
	    return {
	    }
		},
		mounted () {},
		computed: {
			...mapGetters( ['getLocale'] )
		},
		methods: {},
		watch: {
			/* $route(to, from) {
				// react to route changes...
				console.log('From: ' + to)
				console.log('To: ' + to)

    	} */
		},
	}
</script>